
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.93","height":"19.93"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.18 9.965A9.215 9.215 0 119.965.75a9.215 9.215 0 019.215 9.215zM9.965 5.358v4.607l3.686 2.764","fill":"none"}})])
          )
        }
      }
    